import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=6e5d85ce&scoped=true&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=6e5d85ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d85ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mihailoff/apps/quantify-github/services/connect/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5d85ce')) {
      api.createRecord('6e5d85ce', component.options)
    } else {
      api.reload('6e5d85ce', component.options)
    }
    module.hot.accept("./NewTicket.vue?vue&type=template&id=6e5d85ce&scoped=true&", function () {
      api.rerender('6e5d85ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/NewTicket.vue"
export default component.exports